<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/car/index"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>

      <el-drawer
        :title="isEdit?'编辑车辆信息':'新增车辆信息'"
        :visible.sync="isShowDrawer"
        direction="rtl"
      >
        <div style="padding: 40px" v-loading="loading">
          <el-form ref="form" :model="formData" :rules="rules" labelWidth="120px" size="medium">
            <el-form-item label="行驶证扫描">
              <el-upload
                class="uploader"
                action="#"
                :show-file-list="false"
                :on-change="handleChangeFile"
                :before-upload="beforeUpload"
                :auto-upload="false"
              >
                <el-button type="primary">上传行驶证照片</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="车牌号" prop="carNo">
              <el-input v-model="formData.carNo" required></el-input>
            </el-form-item>
            <el-form-item label="车架号" prop="vin">
              <el-input v-model="formData.vin"></el-input>
            </el-form-item>
            <el-form-item label="发动机号" prop="engineNo">
              <el-input v-model="formData.engineNo" required></el-input>
            </el-form-item>
            <el-form-item label="初登日期" prop="beginDate">
              <div>
                <el-date-picker
                  style="width: 100%"
                  v-model="formData.beginDate"
                  type="date"
                  placeholder="选择初登日期"
                >
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="使用性质" prop="usetype">
              <div>
                <el-select
                  style="width: 100%"
                  v-model="formData.usetype"
                  placeholder="使用性质"
                >
                 <el-option label="-" value="-"></el-option>
                  <el-option label="营运" value="营运"></el-option>
                  <el-option label="非营运" value="非营运"></el-option>
				  <el-option label="预约出租客运" value="预约出租客运"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="车型" prop="vin">
              <div>
                <el-select
                  style="width: 100%"
                  v-model="formData.carType"
                  placeholder="车型"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in $store.state.app.carType"
                    :key="index"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="品牌型号" prop="brandType" >
              <el-input v-model="formData.brandType" required></el-input>
            </el-form-item>
            <el-form-item label="核定载客" prop="passengerCount">
              <el-input v-model="formData.passengerCount" required></el-input>
            </el-form-item>
            <el-form-item label="核定载质量">
              <el-input v-model="formData.loadWeight" required></el-input>
            </el-form-item>
            <el-form-item label="新车价">
              <el-input v-model="formData.newPrice" required></el-input>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";
import { rules } from './rules'

export default {
  name: "Car",
  comments: {},
  data() {
    return {
      tableData: [],
      isShowDrawer: false,
      formData: {},
      searchData: {},
      isEdit: false,
      imageUrl: '',
      loading: false,
    };
  },
  computed: {
    columns,
    searchFormOption,
    rules
  },
  created() {
    this.$store.dispatch('app/getCarType')
	this.$store.dispatch('app/getUseType')
  },
  methods: {
    add() {
      this.formData = {};
      this.isShowDrawer = true;
      this.$refs?.form?.clearValidate()
    },

    edit(row) {
      this.formData = row;
      this.isEdit = true;
      this.isShowDrawer = true;
    },

    del(row) {
      this.$confirm("是否确认删除该车辆信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/car/del",
              {
                carId: row.carId,
              },
              "删除"
            )
            .then(() => {
              this.$refs.baseTable.searchData();
            });
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "formData",
            message: "已取消操作",
          });
        });
    },

    // 图片上传之前
    beforeUpload(file) {
      console.log(file)
    },
    
    async handleChangeFile(file) {
      console.log(file)
      this.loading = true
      const fd = new FormData()

      fd.append('img', file.raw)
      fd.append('path', '20')
      console.log(fd)
      const res = await this.$api.upload('/admin/upload/upload_driving', fd)
      this.loading = false
      if(!res) return
      if(!res.data.is_license) {
        this.$message.warning('只支持行驶证图片')
        return
      }
      // beginDate 20200909
      const year = res.data.info?.beginDate.slice(0, 4)
      const month = res.data.info?.beginDate.slice(4, 6)
      const day = res.data.info?.beginDate.slice(6, 8)
      console.log(`${year}-${month}-${day}`)
      this.formData = {
        ...this.formData,
        ...res.data.info,
        beginDate: new Date(`${year}-${month}-${day}`),
      }

      console.log(this.formData, res, '------res')
    },

    onSubmit() {
      this.$refs.form.validate((v) => {
        if(v) {
          this.$api.post("/admin/car/save", this.formData, "更新").then(() => {
            this.isShowDrawer = false;
            this.$refs.baseTable.searchData();
          });
        }
      })
      
    },

    // 点击搜索
    handleSearch() {
      console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },

    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
